import { useTranslation } from "react-i18next";
import { GetPsParams } from "../../../../api/model";
import { useGetPs } from "../../../../api/pss/pss";
import { useDefaultOptions } from "../../../../hooks/api";
import ErrorComponent from "../../../atoms/ErrorComponent";
import WaitComponent from "../../../atoms/WaitComponent";
import PsDetails, { PsDetailsPsGetterCommonProps } from "./PsDetails";

interface Props extends PsDetailsPsGetterCommonProps {
  /** このコンポーネントで取得する PS のバージョン ID。 */
  psVersionId: number;
}

/** PS を取得するコンポーネント。PsDetails のラッパー。 */
function PsGetter(
  {
    mode,
    psVersionId,
    ...props
  }: Props
) {
  // i18n 用。
  const {
    // t,
    i18n,
  } = useTranslation();

  const defaultOptions = useDefaultOptions(i18n.language);

  // PS 編集画面を表示する際の PS 情報取得の時、
  // /pss/{ps_version_id}?edit_flag=1
  // のように edit_flag=1 を付けて呼ぶ。
  // PS 編集画面表示時には、このパラメータをつけて、PS バージョン ID として (改廃案ではなく) 承認済の最新版の PS バージョン ID を getPs のパラメータとして渡すと、戻り値として、改廃案がない場合は最新版の PS データを、改廃案がすでにある場合は改廃案の PS データを返す。
  // PS 編集画面の改廃案保存ボタンクリック時には、PS 更新 (putPs) を呼ぶが、その際の PS バージョン ID は、getPs で戻ってくる PS バージョン ID (改版案がない場合は最新版、ある場合は改廃案のPSバージョンID) を渡す。

  /** PS 取得 API 呼び出し。 */
  const getPsResponse = useGetPs(
    psVersionId,
    { edit_flag: (mode === 'Edit') ? 1 : 0 } as unknown as GetPsParams,
    defaultOptions
  );

  if (getPsResponse.isLoading) {
    return (
      <div className="browsefr">
        <WaitComponent />
      </div>
    );
  }

  if (getPsResponse.isError || !getPsResponse.data || !getPsResponse.data.data) {
    return (
      <div className="browsefr">
        <ErrorComponent error={getPsResponse.error} />
      </div>
    );
  }

  return (
    <PsDetails
      mode={mode}
      ps={{ ...getPsResponse.data.data }}
      {...props}
    />
  );
}

export default PsGetter;